import { useMemo } from 'react';
import { Button, useNavigate, useI18n, useInfiniteQuery } from '@ywwwtseng/react-kit';
import { Select } from '@/components/ui/Select';
import { Plus } from 'lucide-react';
import { ChatPhoto } from './ChatPhoto';
import type { SelectTgChat } from '@/types';

export function SelectChat({
  hidePrivateChats = false,
  value,
  onChange,
}: {
  hidePrivateChats?: boolean;
  value: string | null;
  onChange: (chat_id: string) => void;
}) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { data, fetchNextPage } = useInfiniteQuery<SelectTgChat[]>('allowed_gift_chats', {
    type: 'offset',
    params: {
      limit: 20,
    },
    refetchOnMount: true,
  });

  const chats = useMemo(() => {
    const list = data ?? [];
    if (hidePrivateChats) {
      return list.filter((chat) => !!chat.username);
    }
    return list;
  }, [data, hidePrivateChats]);

  const options = useMemo(() => {
    return [
      ...(chats?.map((chat) => ({
        name: chat.name,
        key: chat.id,
        description: chat.username ? `@${chat.username}` : undefined,
        icon: <ChatPhoto chat={chat} />,
      })) ?? []),
    ];
  }, [chats]);

  return (
    <Select
      searchable
      action={
        <Button
          variant="icon"
          color="primary"
          size="sm"
          onClick={() => navigate('AddChat')}
        >
          <Plus width={20} height={20} />
        </Button>
      }
      value={value}
      placeholder={t('gift.tg_chat')}
      options={options}
      onChange={onChange}
      onScrollEnd={fetchNextPage}
    />
  );
}
